import {
  IGlobalProduct,
  ILicensedProperty,
  ILicensor,
  IRequestStatusReason,
} from "../../../types/data.interface";
import {
  IMasterArtworkRequestHistory,
  MasterArtworkCollectionActionType,
  MasterArtworkCollectionActionTypes,
  MasterArtworkCollectionState,
} from "./data.type";

const setGlobalProduct = (
  globalProduct: IGlobalProduct[] | null,
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_GLOBAL_PRODUCT,
  payload: { global_product: globalProduct },
});

const setLicensor = (
  licensor: ILicensor | null,
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_LICENSOR,
  payload: { licensor },
});

const setLicensedProperty = (
  licensedProperty: ILicensedProperty | null,
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_LICENSED_PROPERTY,
  payload: { licensed_property: licensedProperty },
});

const setName = (name: string): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_NAME,
  payload: { name },
});
const setCode = (code: string): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_CODE,
  payload: { code },
});
const setLaunchDate = (
  launch_date: string,
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_LAUNCH_DATE,
  payload: { launch_date },
});

const setUnsavedChanges = (
  hasUnsavedChanges: boolean,
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_UNSAVED_CHANGES,
  payload: { hasUnsavedChanges },
});

const addRequestHistoryRecords = (
  historyRecords: IMasterArtworkRequestHistory[],
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.ADD_REQUEST_HISTORY,
  // @ts-ignore
  payload: { requestHistory: historyRecords },
});

const setSubmitComment = (
  comment: string,
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_SUBMIT_COMMENT,
  payload: { submitComment: comment },
});

const setApproveComment = (
  comment: string,
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_APPROVE_COMMENT,
  payload: { approveComment: comment },
});

const setRejectComment = (
  comment: string,
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_REJECT_COMMENT,
  payload: { rejectComment: comment },
});

const setRejectReason = (
  reason: IRequestStatusReason,
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_REJECT_REASON,
  payload: { rejectReason: reason },
});

const setCollection = (
  collection: MasterArtworkCollectionState,
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_COLLECTION,
  payload: { ...collection },
});
const resetState = (): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.RESET_STATE,
  payload: {},
});

const setRequestStatus = (
  requestStatus: string | null,
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_REQUEST_STATUS,
  payload: { requestStatus },
});

const setIsValid = (
  isValid: boolean | null,
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_IS_VALID,
  payload: { isValid },
});

const setIsReadOnly = (
  isReadOnly: boolean,
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_IS_READ_ONLY,
  payload: { isReadOnly },
});

const setFiltersFromStorage = (
  filters: Partial<MasterArtworkCollectionState>,
): MasterArtworkCollectionActionType => ({
  type: MasterArtworkCollectionActionTypes.SET_FILTERS_FROM_STORAGE,
  payload: { ...filters },
});

export const MasterArtworkCollectionActions = {
  resetState,
  setCollection,
  setLicensor,
  setLicensedProperty,
  setName,
  setLaunchDate,
  setCode,
  setGlobalProduct,
  setUnsavedChanges,
  addRequestHistoryRecords,
  setSubmitComment,
  setApproveComment,
  setRejectComment,
  setRejectReason,
  setRequestStatus,
  setIsValid,
  setIsReadOnly,
  setFiltersFromStorage,
};
